import * as React from "react";
import { cn } from "@/lib/utils";

export interface SwitchProps {
    checked: boolean;
    onCheckedChange?: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
    "data-testid"?: string;
}

/**
 * Minimal toggle that doesn't pull in any new Radix dependency. Mirrors the
 * shadcn/ui Switch surface (`checked` + `onCheckedChange`) so it's a
 * drop-in if the project ever upgrades.
 */
export function Switch({ checked, onCheckedChange, disabled, className, ...rest }: SwitchProps): React.ReactNode {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => !disabled && onCheckedChange?.(!checked)}
            className={cn(
                "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors",
                "border border-input outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
                checked ? "bg-primary" : "bg-muted",
                disabled && "cursor-not-allowed opacity-50",
                className,
            )}
            data-testid={rest["data-testid"]}
        >
            <span
                className={cn(
                    "inline-block h-4 w-4 rounded-full bg-background shadow transition-transform",
                    checked ? "translate-x-[18px]" : "translate-x-[2px]",
                )}
            />
        </button>
    );
}
